import { useState, useEffect } from 'react'
import { Form, Row, Col, Badge, InputGroup, Button } from 'react-bootstrap'
import { useAppStore } from '../stores/appStore'

const TaskSelector = ({ selectedTasks, onTaskSelectionChange, taskManager }) => {
  const { taskSelector, setTaskSelectorState } = useAppStore()
  const { selectedCategory } = taskSelector
  const [searchTerm, setSearchTerm] = useState('')
  const [tasks, setTasks] = useState([])
  const [categories, setCategories] = useState([])

  useEffect(() => {
    if (taskManager) {
      const allTasks = taskManager.getAllTasks()
      setTasks(allTasks)

      // 提取分类
      const categorySet = new Set(allTasks.map(task => task.category))
      setCategories([
        { value: 'all', label: '全部分类', count: allTasks.length },
        ...Array.from(categorySet).map(cat => ({
          value: cat,
          label: getCategoryLabel(cat),
          count: allTasks.filter(task => task.category === cat).length
        }))
      ])
    }
  }, [taskManager])



  const getCategoryLabel = (category) => {
    const categoryMap = {
      'daily': '活跃度',
      'resource': '资源收获',
      'activity': '活动',
      'reward': '奖励领取',
      'general': '通用类',
      'character': '武将类',
      'battle': '战斗类',
    }
    return categoryMap[category] || category
  }

  const getCategoryColor = (category) => {
    const colorMap = {
      'resource': 'success',
      'character': 'primary',
      'battle': 'danger',
      'reward': 'warning',
      'activity': 'info',
      'general': 'secondary',
      'example': 'dark'
    }
    return colorMap[category] || 'secondary'
  }

  const filteredTasks = tasks.filter(task => {
    const matchesSearch = task.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      task.description.toLowerCase().includes(searchTerm.toLowerCase())
    const matchesCategory = selectedCategory === 'all' || task.category === selectedCategory
    return matchesSearch && matchesCategory
  })

  const handleTaskToggle = (taskId) => {
    const newSelection = selectedTasks.includes(taskId)
      ? selectedTasks.filter(id => id !== taskId)
      : [...selectedTasks, taskId]
    onTaskSelectionChange(newSelection)
  }

  const handleSelectAll = () => {
    const allFilteredTaskIds = filteredTasks.map(task => task.id)
    onTaskSelectionChange(allFilteredTaskIds)
  }

  const handleSelectNone = () => {
    onTaskSelectionChange([])
  }

  return (
    <div>


      {/* 搜索和筛选 */}
      <Row className="mb-2 g-2">
        <Col md={4}>
          <InputGroup size="sm">
            <InputGroup.Text>🔍</InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="搜索任务..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col md={3}>
          <Form.Select
            size="sm"
            value={selectedCategory}
            onChange={(e) => setTaskSelectorState({ selectedCategory: e.target.value })}
          >
            {categories.map(cat => (
              <option key={cat.value} value={cat.value}>
                {cat.label} ({cat.count})
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col md={5}>
          <div className="d-flex gap-1">
            <Button variant="outline-primary" size="sm" onClick={handleSelectAll}>
              全选
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={handleSelectNone}>
              清空
            </Button>
            <span className="ms-2 text-muted small align-self-center">
              已选: {selectedTasks.length}
            </span>
          </div>
        </Col>
      </Row>

      {/* 任务列表 */}
      <div className="row g-2">
        {filteredTasks.map(task => (
          <div key={task.id} className="col-md-6 col-lg-4 col-xl-3">
            <div
              className={`border rounded p-2 d-flex align-items-center ${selectedTasks.includes(task.id) ? 'border-primary bg-primary bg-opacity-10' : 'border-light'}`}
              style={{ cursor: 'pointer', minHeight: '48px' }}
              onClick={() => handleTaskToggle(task.id)}
            >
              <Form.Check
                type="checkbox"
                checked={selectedTasks.includes(task.id)}
                onChange={() => handleTaskToggle(task.id)}
                onClick={(e) => e.stopPropagation()}
                className="me-2"
              />
              <span className="me-2 fs-5">{task.icon}</span>
              <span className="fw-medium text-truncate flex-grow-1">{task.name}</span>
              <Badge bg={getCategoryColor(task.category)} size="sm" className="ms-1">
                {getCategoryLabel(task.category)}
              </Badge>
            </div>
          </div>
        ))}
      </div>

      {filteredTasks.length === 0 && (
        <div className="text-center text-muted py-4">
          <p>没有找到匹配的任务</p>
        </div>
      )}

      {/* 选择统计 */}
      {selectedTasks.length > 0 && (
        <div className="mt-2 p-2 bg-light rounded">
          <small className="text-muted">
            已选择 {selectedTasks.length} 个任务
          </small>
        </div>
      )}
    </div>
  )
}

export default TaskSelector
